export const local = '';

export const USER_API_URL = process.env.NEXT_PUBLIC_USER_API_URL;
export const NAMESPACE = process.env.NEXT_PUBLIC_NAMESPACE;

export const backendURL =
	USER_API_URL && NAMESPACE ? `${USER_API_URL}${NAMESPACE}/v1` : local;

export const backendURL_V3 =
	USER_API_URL && NAMESPACE ? `${USER_API_URL}${NAMESPACE}/v3` : local;
